import LoginForm from './LoginForm'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { getStrategies } from '../../redux/slices'
import { DefaultState } from '../../types'
import { LoadIndicator } from 'devextreme-react'
import Register from './Register'
import SSOItems from './SSOItems'
import { useLocation, useNavigate } from 'react-router-dom'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'

const LoginPageBody = () => {
  const { loading, form, sso, allow_register_users, error } =
    useSelector((state: DefaultState) => state.strategies)
  const session = useSelector((state: DefaultState) => state.session)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getStrategies())
  }, [])

  useEffect(() => {
    if (session.data.accessToken) {
      const oidcAfter = new URLSearchParams(location.search).get('oidc_after')
      if (oidcAfter) {
        window.location.replace(`/auth/oauth2/resume?request_id=${encodeURIComponent(oidcAfter)}`)
        return
      }
      //todo this should be moved to a different place? does the nav auth module handle this
      const pathname = location?.state?.from?.pathname
      if(pathname && pathname !== "/ui2/login" && pathname !== "/ui2/logout"){
        navigate(
          pathname,
          { replace: true }
        )
      } else {
        window.location.replace('/ui/#!/')
      }
    }
  }, [session.data.accessToken])

  if (error) {
    return (
      <ICSErrorCard
        code={error ? 'auth' : 'error'}
        message={error ? 'Authorization Error' : ''}
        fields={[]}
      />
    )
  } else if (loading || session.data.accessToken || session.loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadIndicator />
      </div>
    )
  } else {
    return (
      <>
        {form && <LoginForm />}
        <SSOItems ssoItems={sso} oidcAfter={new URLSearchParams(location.search).get('oidc_after')} />
        {/* {sso.length > 0 && <SSOItems ssoItems={sso} />} */}
        {allow_register_users && <Register />}
      </>
    )
  }
}

export default LoginPageBody